import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getstudylevel, setStudyLevel } from "../actions/studyLevelActions";

const StudyLevel = React.memo((props) => {
  const dispatch = useDispatch();

  const studylevelList = useSelector((state) => state.studylevelList);
  const { studyLevels, loading, error } = studylevelList;

  const [checkk, setCheckk] = useState([]);

  // const studyLevelset = useSelector((state)=>state.studyLevelset)
  // const {levls} = studyLevelset

  const handleChange = (e) => {
    let { value, checked } = e.target;
    let tempcheck = checkk;
    if (checked) {
      tempcheck.push({ name: value });
    } else {
      tempcheck = tempcheck.filter((ck) => ck.name !== value);
    }

    let str = "";
    for (var i = 0; i < tempcheck.length; i++) {
      str += tempcheck[i].name + ",";
    }
    str = str.replace(/,\s*$/, "");
    setCheckk(tempcheck);
    props.handleAchange(str);
  };

  // const handleCh = (dtd, vl) => {
  //     if (vl) {
  //         if (checkk) {
  //             setCheckk({ name: dtd })
  //             console.log("tr")
  //         } else {
  //             setCheckk([...checkk, { name: dtd }])
  //             console.log("fl")
  //         }
  //         console.log(dtd + ' yes')
  //     } else {
  //         setCheckk(checkk.filter((chk) => chk.name !== dtd))
  //         console.log(dtd + ' no')
  //     }
  //     console.log(checkk)
  // }

  useEffect(() => {
    if (!studyLevels) {
      dispatch(getstudylevel());
    }
  }, [studyLevels]);
  
  return loading ? (
        <>loading...</>
      ) : 
          studyLevels ? (
            studyLevels.map((studyLevel, i) => (
              <div key={i + 789} className="form-check">
                <label className="form-check-label" for={studyLevel.Id}>
                  <input
                    type="checkbox"
                    className="form-check-input"
                    value={studyLevel.Study_Level}
                    onChange={(e) => handleChange(e)}
                  />
                  {studyLevel.Study_Level}
                </label>
              </div>
            ))
          ) : (
            <>
              <option>Loading...</option>
            </>
      )}
  );

export default StudyLevel;
